// extracted by mini-css-extract-plugin
export var cluster = "map-module--cluster--1IMZI";
export var label = "map-module--label--3v3_o";
export var customClustericon = "map-module--customClustericon--1mpI3";